export default __webpack_public_path__ + "static/media/logo_dark_blue_crop.c27112ce.png";